import React from "react";
// NOTE: BrowserRouter is intentionally NOT imported here — it wraps <App />
// itself over in App.jsx so that other router-aware components rendered
// next to <Routes /> (e.g. ProfileSetupPrompt, which calls useLocation)
// have access to the router context. See the comment in App.jsx.
import { Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ReportsAndAnalytics from './pages/reports-and-analytics';
import IEPGoalsAndObjectivesTracking from './pages/iep-goals-and-objectives-tracking';
import AIInsightsPage from './pages/ai-powered-insights-and-recommendations';
import Login from './pages/login';
import MultiUserCollaborationHub from './pages/multi-user-collaboration-hub';
import Dashboard from './pages/dashboard';
import BehavioralIncidentLogging from './pages/behavioral-incident-logging';
import StudentProfileManagement from './pages/student-profile-management';
import PrintStudentSummary from './pages/print-student-summary';
import PrintReports from './pages/print-reports';
import PBISResourcesPage from './pages/pbis-resources';
import HelpAndManualPage from './pages/help-and-manual';
import PreferencesPage from './pages/preferences';
import ForgotPasswordPage from './pages/forgot-password';
import ResetPasswordPage from './pages/reset-password';
import GoLivePage from './pages/go-live';
import PaperTrackersPage from './pages/paper-trackers';
import StudentsImportPage from './pages/students-import';
import GoalsImportPage from './pages/goals-import';
import CheatSheetPage from './pages/cheat-sheet';
import StudentProgressTracker from './pages/student-progress-tracker';
import StudentCheckIn from './pages/student-check-in';

const Routes = () => {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AIInsightsPage />} />
        <Route path="/reports-and-analytics" element={<ReportsAndAnalytics />} />
        <Route path="/iep-goals-and-objectives-tracking" element={<IEPGoalsAndObjectivesTracking />} />
        <Route path="/progress-tracker" element={<StudentProgressTracker />} />
        <Route path="/tracker" element={<StudentProgressTracker />} />
        <Route path="/check-in" element={<StudentCheckIn />} />
        <Route path="/check-in/:studentId" element={<StudentCheckIn />} />
        <Route path="/ai-powered-insights-and-recommendations" element={<AIInsightsPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/multi-user-collaboration-hub" element={<MultiUserCollaborationHub />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/behavioral-incident-logging" element={<BehavioralIncidentLogging />} />
        <Route path="/student-profile-management" element={<StudentProfileManagement />} />
        <Route path="/student-profile-management/:studentId" element={<StudentProfileManagement />} />
        <Route path="/print/student/:studentId" element={<PrintStudentSummary />} />
        <Route path="/print/reports/:reportType" element={<PrintReports />} />
        <Route path="/pbis-resources" element={<PBISResourcesPage />} />
        <Route path="/help" element={<HelpAndManualPage />} />
        <Route path="/help-and-manual" element={<HelpAndManualPage />} />
        <Route path="/preferences" element={<PreferencesPage />} />
        <Route path="/profile" element={<PreferencesPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/go-live" element={<GoLivePage />} />
        <Route path="/setup" element={<GoLivePage />} />
        <Route path="/paper-trackers" element={<PaperTrackersPage />} />
        <Route path="/print-forms" element={<PaperTrackersPage />} />
        <Route path="/students/import" element={<StudentsImportPage />} />
        <Route path="/import-roster" element={<StudentsImportPage />} />
        <Route path="/goals/import" element={<GoalsImportPage />} />
        <Route path="/import-iep-goals" element={<GoalsImportPage />} />
        <Route path="/cheat-sheet" element={<CheatSheetPage />} />
        <Route path="/district-cheat-sheet" element={<CheatSheetPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
};

export default Routes;
